import React from 'react'
import Navbar from '../../Components/Navbar'

import AboutHeader from '../../Components/AboutHeader'
import AboutOur from '../../Components/AboutOur'
import Business from '../../Components/Business'
import Footer from '../../Components/Footer'

const About = () => {
  return (
    <div>
      <Navbar/>
      <AboutHeader/>
      <AboutOur/>
      <Business/>
      <Footer/>
      
    </div>
  )
}

export default About
